export const appInPlayStoreLink = 'https://play.google.com/store/apps/details?id=com.terraapp';

export const appInAppStoreLink =
    'https://apps.apple.com/br/app/terra-investimentos-digital/id1550325170';
